<section class="table-wrapper">

  <cc-plan-features-table [plans$]="plans$" [rowsDefinition]="mainTable?.rows">
    <div class="main-header key-features" table staticHeader translate>{{mainTable?.headerKey}}</div>

    <ng-template let-column>
      <cc-plan-brief-header class="main-header"
                            [plan]="column.plan"
                            [buttonKey]="isCurrentSubscription(column.plan) ? 'PLANS.MODIFY' : 'PLANS.CHOOSE_PLAN'"
                            [canSubscribe]="subscribeEnabled(column.plan)"
                            (subscribeClicked)="onSubscribePlan($event)"></cc-plan-brief-header>
    </ng-template>
  </cc-plan-features-table>

  <div class="full-comparison"
       translate
       (click)="showFullComparision()"
       *ngIf="!fullComparision">FULL_COMPARISON</div>

  <ng-container *ngIf="fullComparision">

    <cc-plan-features-table *ngFor="let table of secondaryTables"
                            [plans$]="plans$"
                            [rowsDefinition]="table.rows"
                            [fullWidthStaticHeader]="true">
      <div table staticHeader class="sub-header" translate>{{table.headerKey}}</div>
    </cc-plan-features-table>


    <cc-plan-features-table [plans$]="plans$" [rowsDefinition]="[]">
      <ng-template let-column>
        <cc-plan-brief-header class="main-footer"
                              [plan]="column.plan"
                              [buttonKey]="isCurrentSubscription(column.plan) ? 'PLANS.MODIFY' : 'PLANS.CHOOSE_PLAN'"
                              [compact]="true"
                              [canSubscribe]="subscribeEnabled(column.plan)"
                              (subscribeClicked)="onSubscribePlan($event)"></cc-plan-brief-header>
      </ng-template>
    </cc-plan-features-table>

  </ng-container>

  <div class="full-comparison"
       translate
       (click)="fullComparision = false"
       *ngIf="fullComparision">SHOW_LESS</div>

</section>
